<template>
  <div>
    <div
      class="ts-w-full ts-h-full ts-rounded-lg ts-shadow-md ts-bg-white ts-col-span-4 ts-overflow-hidden"
    >
      <ts-loading-banner :loading="loading">
        <table class="ts-w-full">
          <thead>
            <tr class="ts-bg-gray-200">
              <th
                class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-pl-5 ts-text-heading-color ts-py-1"
              >{{ $t('gameConfirmResult.gameSetName') }}</th>
              <th
                class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-text-heading-color"
              >{{ $t('gameConfirmResult.resultDate') }}</th>
              <th
                class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-text-heading-color"
              >{{ $t('gameConfirmResult.closeTime') }}</th>
              <th
                class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-text-heading-color"
              >{{ $t('gameConfirmResult.result') }}</th>
              <th
                class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-text-heading-color ts-pr-5"
              >{{ $t('actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(game, index) in game_set_lists"
              :key="index"
              class="ts-cursor-pointer hover:ts-bg-blue-200 ts-transaction ts-duration-500"
            >
              <td class="ts-pl-5 ts-py-6 ts-whitespace-no-wrap">
                <span
                  class="winning-date ts-block ts-text-base ts-text-para-color ts-font-robot"
                >{{ game.game_set_name }}</span>
              </td>
              <td class="ts-py-6">
                <span
                  class="winning-date ts-block ts-text-base ts-text-para-color ts-font-robot"
                >{{ game.result_date }}</span>
              </td>
              <td class="ts-py-6">
                <span
                  class="winning-date ts-block ts-text-base ts-text-para-color ts-font-robot"
                >{{ game.close_time }}</span>
              </td>
              <td>
                <ul class="number-list ts-flex ts-space-x-2 ts-my-auto">
                  <li
                    v-for="(result, index) in splitResult(game.game_set_result)"
                    :key="index"
                    class="ts-leading-8 ts-font-robot ts-rounded-full ts-text-center ts-text-heading-color ts-border ts-border-gray-500 ts-text-base ts-inline-block ts-h-8 ts-w-8"
                  >{{ result }}</li>
                </ul>
              </td>
              <td class="ts-text-center ts-w-4">
                <a
                  href="#"
                  v-if="game.game_set_result.length > 1"
                  @click.prevent="confirmResult(game, index)"
                >
                  <i class="far fa-check-circle ml-2"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmPassword from './confirm_pwd'
import { Errors } from 'form-backend-validation'
export default {
  name: 'gameConfirmForm',
  components: {
    ConfirmPassword
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      action_index: null,
      game_set_lists: [],
      model: {
        password: null,
        result_date: null,
        game_set_id: null,
        result_number: null,
        is_released: true
      }
    }
  },
  created() {
    this.fetchGame()
  },
  methods: {
    ...mapActions('administrator/gameConfirmResult', ['getGameSet', 'store']),
    fetchGame() {
      this.loading = true
      this.getGameSet()
        .then(result => {
          this.game_set_lists = result.data
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    splitResult(result) {
      if (!result.length > 1) return []
      var string = _.union(result.map(el => el.result_number))[0]
      if (string != undefined) {
        return string.split(',')
      }
    },
    confirmResult(record) {
      this.model.result_date = record.result_date
      this.model.game_set_id = record.game_set_id
      this.model.result_number = record.game_set_result[0].result_number
      this.$confirm({
        title: this.$t('gameConfirmResult.do_you_want_to_release'),
        content: h =>
          h(ConfirmPassword, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('gameConfirmResult.password')
            }
          }),
        okText: this.$t('yes'),
        cancelText: this.$t('no'),
        zIndex:1025,
        centered: true,
        onOk: () => {
          return this.store(this.model)
            .then(response => {
              this.$toasted.success(response.message)
              this.$emit('fetchData')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    }
  }
}
</script>
